import React from 'react';
import { motion } from 'framer-motion';
import HeroSection from './sections/HeroSection';
import TipsSection from './sections/TipsSection';
import PainPointsSection from './sections/PainPointsSection';
import PackageSection from './sections/PackageSection';
import CTASection from './sections/CTASection';
import TestimonialsSection from './sections/TestimonialsSection';
import AuthoritySection from './sections/AuthoritySection';
import ClosingSection from './sections/ClosingSection';

const SalesFunnel = () => {
  return (
    <motion.div 
      className="min-h-screen bg-gradient-to-b from-orange-50 to-red-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <HeroSection />
      <TipsSection />
      <PainPointsSection />
      <PackageSection />
      <TestimonialsSection />
      <AuthoritySection />
      <ClosingSection />
      
    </motion.div>
  );
};

export default SalesFunnel;